mutation DeleteImpactMeasurementItem($id: ID!) {
  deleteImpactMeasurementItem(input: { id: $id }) {
    success
  }
}
